// Документы (макет «Документы»): пять документов с датой редакции и продавец — с сервера.
import { Link } from "react-router";
import { isApiError } from "../../api/client";
import { useDocuments, useMe } from "../../app/queries";
import { SiteFooter } from "../../site/SiteFooter";
import { useIsMiniApp } from "../../telegram/channel";
import { Icon } from "../../ui/icons";
import { PageHeader } from "../../ui/PageHeader";
import { ProblemScreen } from "../../ui/ProblemScreen";
import { Screen } from "../../ui/Screen";
import styles from "./Docs.module.css";
import { formatRevision } from "./revision";

// Подвал страниц документов: вопросы и, после входа, заказы; «Бот в Telegram» добавляет
// сам подвал.
export function useDocsFooterLinks() {
  const { data: me } = useMe();
  return [{ to: "/faq", label: "Вопросы" }, ...(me != null ? [{ to: "/orders", label: "Мои заказы" }] : [])];
}

// Сервер не ответил: «Нет связи» и «Повторить» вместо пустой страницы.
export function DocsOffline({ onRetry }: { onRetry: () => void }) {
  return (
    <ProblemScreen icon="offline" title="Нет связи" action={{ text: "Повторить", onClick: onRetry }}>
      Проверь интернет и попробуй ещё раз.
    </ProblemScreen>
  );
}

export function DocsScreen() {
  const isMiniApp = useIsMiniApp();
  const footerLinks = useDocsFooterLinks();
  const { data, failureReason, refetch } = useDocuments();
  if (data === undefined && isApiError(failureReason) && failureReason.kind === "network") {
    return <DocsOffline onRetry={() => void refetch()} />;
  }
  return (
    <>
      <Screen direction="miniature" header={<PageHeader title="Документы" backTo="/" />}>
        <div className={styles.content}>
          <div className={styles.titleBlock}>
            <h1 className="h2">Документы</h1>
            <p className="text muted">Условия покупки и возврата, и как мы обращаемся с твоими фото.</p>
          </div>
          {data === undefined ? (
            <p role="status" className="text muted">
              Загружаем документы…
            </p>
          ) : (
            <>
              <ul className={`${styles.card} ${styles.list}`} aria-label="Документы">
                {data.documents.map((document) => (
                  <li key={document.id}>
                    <Link to={`/docs/${document.id}`}>
                      <span>
                        <span style={{ fontWeight: 600 }}>{document.title}</span>
                        <span className="small muted">{document.about}</span>
                        <span className="mono muted">редакция от {formatRevision(document.revision)}</span>
                      </span>
                      <Icon name="forward" size={20} />
                    </Link>
                  </li>
                ))}
              </ul>
              <div className={`${styles.card} ${styles.seller}`}>
                <span className="small muted">Продавец</span>
                <span style={{ fontWeight: 600 }}>
                  {data.seller.name}, {data.seller.status_ru}
                </span>
                <span className="small muted">
                  ИНН {data.seller.inn} · почта {data.seller.email}
                </span>
              </div>
            </>
          )}
        </div>
      </Screen>
      {!isMiniApp && <SiteFooter links={footerLinks} />}
    </>
  );
}
